export enum errorMessage {
  DATE_LIKE_INPUT_ERROR_MESSAGE = 'A date-like value was entered for an Input that is not formatted as a date. Because date formats can be ambiguous when entered outside of Excel, dates can only be entered in the CloudCast assumption editor via Inputs that are formatted as a date (and thus use a date picker). Please contact Trinity support with any questions.',
}

export enum warnMessage {
  ALL_GROUPS_LOCKED_ERROR_MESSAGE = 'All of the groups included in this publish request are locked.',
}
